<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em; padding-top:15px;">Cyril O’Brien is a retired London Fire Brigade Borough Commander, who since leaving the LFB has moved in the world of Emergency Planning, and is currently working for the London Borough of Bexley.</p>
<p style="text-indent:00em; padding-top:15px;">Upon his retirement, finding additional time on his hands, Cyril made a foray into trying to write a book. His first effort being successful, prompted him to set about this edition as his number two.</p>
<p style="text-indent:00em; padding-top:15px;">He is married to Jackie and they have three very talented children, Georgina, Anne-Marie and Spencer. They have also been graced with three grandchildren, Coray, Anaya and Kaylan.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?912a3af4